import {
  OrganizationEntitiesArgType,
  OrganizationEntitiesArg
} from './organization-entities-arg'

export interface EntitiesMutationArgs {
  readonly input?: OrganizationEntitiesArg
}

export const entitiesMutationArgs = {
  input: {
    type: OrganizationEntitiesArgType
  }
}
